export enum CognitiveTestTypeEnums {
  NONOGO = 'no-no-go',
  COGNITIVETESTPVT = 'cognitive-test-pvt',
  GAMBLINGTEST = 'gambling-test',
  WORDPAIRTEST = 'word-pair-test',
}
